import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

const NumOfGifts = () => {
  const numOfGiftsObj = {}

  const { numOfGifts } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (numOfGifts) {
      const numOfGiftsArr = numOfGifts.split('&')

      numOfGiftsArr.forEach((numOfGift) => {
        const gift = numOfGift.split('=')

        numOfGiftsObj[gift[0]] = parseInt(gift[1])
      })
    }

    console.log(numOfGiftsObj)

    if (numOfGiftsObj?.d) localStorage.setItem('numOfDeluxe', numOfGiftsObj.d)
    if (numOfGiftsObj?.s) localStorage.setItem('numOfSample', numOfGiftsObj.s)

    navigate('/')
  }, [navigate, numOfGifts])
}

export default NumOfGifts
